export enum SkillProgression {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}
